import createRootReducer from '@/reducers'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
//{ forceRefresh: false }
export const history = createBrowserHistory()

export default function configureStore(preloadedState?: any) {
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    compose(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        // ... other middlewares ...
      ),
      // redux调试工具
      // (window as any)?.__REDUX_DEVTOOLS_EXTENSION__ &&
      //   (window as any)?.__REDUX_DEVTOOLS_EXTENSION__(),
    ),
  )

  return store
}
export const store = configureStore()
